import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { Divider } from 'primeng/divider';
import { ReportStore } from '@navstation-portal/reporting/data-access/vessel-report';
import {
  OffshoreStockFormStore,
  OffshoreReportStore,
  offshoreStockFormEvents,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { DynamicFormComponent } from '../shared/dynamic-form/dynamic-form.component';
import { TankStockTableComponent } from './sections/tank-stock-table/tank-stock-table.component';
import { TankTransfersComponent } from './sections/tank-transfers/tank-transfers.component';
import { FuelRobComponent } from './sections/fuel-rob/fuel-rob.component';

@Component({
  selector: 're-offshore-stock',
  templateUrl: './offshore-stock.component.html',
  imports: [
    FormsModule,
    DynamicFormComponent,
    TankStockTableComponent,
    TankTransfersComponent,
    Divider,
    FuelRobComponent,
  ],
})
export class OffshoreStockComponent {
  readonly reportStore = inject(ReportStore);
  stockStore = inject(OffshoreStockFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
  object = Object;
  tabId = 'stock';
  sectionId = 'tanks';
  fieldId = 'tankRows';
  events = injectDispatch(offshoreStockFormEvents);
}
